import { aabb2New } from "geom/aabb2Types";
import type { AABB2 } from "geom/aabb2Types";
import type { Vec3 } from "geom/vec3";

export type DrawingCamera = PerspectiveDrawingCamera | OrthographicDrawingCamera;

export enum DrawingCameraType {
  ORTHOGRAPHIC = "ORTHOGRAPHIC",
  PERSPECTIVE = "PERSPECTIVE",
}

export interface OrthographicDrawingCamera {
  readonly type: DrawingCameraType.ORTHOGRAPHIC;
  readonly eye: Vec3;
  readonly target: Vec3;
  readonly up: Vec3;
  readonly left: number;
  readonly right: number;
  readonly bottom: number;
  readonly top: number;
  readonly near: number;
  readonly far: number;
}

export const drawingCameraFullViewAABB: AABB2 = aabb2New(0, 0, 1, 1);

export interface PerspectiveDrawingCamera {
  readonly type: DrawingCameraType.PERSPECTIVE;
  readonly eye: Vec3;
  readonly target: Vec3;
  readonly up: Vec3;
  readonly aspect: number;
  readonly fovDegrees: number; // Vertical FOV
  readonly near: number;
  readonly far: number;

  readonly viewCropAABB: AABB2; // Crop the view, in relative coordinates ranging from 0 to 1. This can be used for an off-center cropping of the rendering, resulting in a sheared projection.
}
